import axios from 'axios';

axios.withCredentials = true;
axios.defaults.headers.common.Authorization = `Bearer ${localStorage.getItem('token')}`;

// eslint-disable-next-line import/prefer-default-export
export class BaseApi {
  constructor(base) {
    this.base = base;
  }

  url = process.env.NODE_ENV !== 'production' ? 'https://tredbackend.test/api/' : 'https://mytredspace.ru/api/';

  get(link) {
    return axios.get(`${this.url}${this.base}${link}`);
  }

  post(link, data, config = {}) {
    return axios.post(`${this.url}${this.base}${link}`, data, config);
  }

  delete(link) {
    return axios.delete(`${this.url}${this.base}${link}`)
  }

  update(link, data) {
    return axios.put(`${this.url}${this.base}${link}`, data);
  }
}
